import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { fontWeights } from "et3-ui-library";

import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";

const HeaderMenuItem = withLiteObserverAndTheme<{
  text: string;
  counter: number;
  isCounterVisible: boolean;
}>((props) => {
  const { text, counter, isCounterVisible } = props;

  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}
    >
      {text}
      {!isCounterVisible ? null : (
        <Chip
          size="small"
          label={counter}
          color={counter > 0 ? "error" : "default"}
          sx={{ fontWeight: fontWeights.bold }}
        />
      )}
    </Box>
  );
});

export default HeaderMenuItem;
